module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-dialog-confirm', {
    ref: "promoteVersionDialog",
    attrs: {
      "md-title": _vm.confirmPromote.title,
      "md-content-html": _vm.promoteContent,
      "md-ok-text": _vm.confirmPromote.ok,
      "md-cancel-text": _vm.confirmPromote.cancel
    },
    on: {
      "close": _vm.promoteVersionConfirm
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "deleteVersionDialog",
    attrs: {
      "md-title": _vm.confirmDelete.title,
      "md-content-html": _vm.confirmDelete.content,
      "md-ok-text": _vm.confirmDelete.ok,
      "md-cancel-text": _vm.confirmDelete.cancel
    },
    on: {
      "close": _vm.deleteVersionConfirm
    }
  }), _vm._v(" "), _c('md-sidenav', {
    ref: "versionsNav",
    staticClass: "md-left"
  }, [_c('md-toolbar', {
    staticClass: "md-dense main-toolbar"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        return _vm.back()
      }
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "md-title"
  }, [_vm._v("History")])], 1), _vm._v(" "), (_vm.activeProjectEntitled) ? _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.saveVersion.apply(null, arguments)
      }
    }
  }, [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "version-name"
    }
  }, [_vm._v("Version Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "version-name",
      "required": ""
    },
    on: {
      "input": _vm.checkVersionTitle
    },
    model: {
      value: (_vm.versionTitle),
      callback: function($$v) {
        _vm.versionTitle = $$v
      },
      expression: "versionTitle"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "comm-error"
  }, [(_vm.errorMessage) ? _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.saveVersion
    }
  }, [_vm._v("Save New Version")])], 1) : _vm._e(), _vm._v(" "), _c('md-list', {
    staticClass: "ql-version-list md-double-line"
  }, [_c('md-list-item', [_c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v("Current Version")]), _vm._v(" "), (!_vm.currentVersion) ? _c('span', [_vm._v("Live Edit")]) : _c('span', [_vm._v(_vm._s(_vm.currentVersion.name))])])]), _vm._v(" "), _c('md-list-item', [(!_vm.currentVersion) ? _c('md-icon', [_vm._v("label")]) : _c('md-icon', [_vm._v("label_outline")]), _vm._v(" "), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v("Live Version")])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button md-list-action",
    on: {
      "click": function($event) {
        return _vm.setActiveVersion(null)
      }
    }
  }, [_c('md-icon', [_vm._v("launch")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Show Version")])], 1)], 1), _vm._v(" "), _c('md-list', [_vm._l((_vm.days), function(filteredVersions, day) {
    return _c('md-list-item', {
      key: day,
      ref: 'day-' + day,
      refInFor: true,
      attrs: {
        "md-expand-multiple": ""
      }
    }, [_c('span', [_c('strong', [_vm._v(_vm._s(day))])]), _vm._v(" "), _c('md-list-expand', [_c('md-list', _vm._l((filteredVersions), function(version) {
      return _c('version-element', {
        key: version.id,
        attrs: {
          "project": _vm.project,
          "version": version,
          "fresh": version.id === _vm.freshVersionId
        },
        on: {
          "promoteVersion": _vm.promoteVersion,
          "deleteVersion": _vm.deleteVersion,
          "close": _vm.emitClose
        }
      })
    }), 1)], 1)], 1)
  }), _vm._v(" "), _vm._l((_vm.autoFolders), function(folder) {
    return _c('md-list-item', {
      key: folder.kind,
      staticClass: "ql-auto-folder",
      attrs: {
        "md-expand-multiple": ""
      },
      on: {
        "click": function($event) {
          return _vm.toggleFolder(folder.kind)
        }
      }
    }, [_c('md-icon', [_vm._v(_vm._s(_vm.openFolders[folder.kind] ? 'folder_open' : 'folder'))]), _vm._v(" "), _c('div', {
      staticClass: "md-list-text-container"
    }, [_c('span', [_c('strong', [_vm._v(_vm._s(folder.title))]), _vm._v(" "), (_vm.autoSaveCapEnabled) ? _c('span', {
      staticClass: "ql-folder-count"
    }, [_vm._v("· " + _vm._s(folder.versions.length) + " of " + _vm._s(_vm.autoSaveCap))]) : _c('span', {
      staticClass: "ql-folder-count"
    }, [_vm._v("(" + _vm._s(folder.versions.length) + ")")])])]), _vm._v(" "), _c('md-list-expand', [_c('md-list', _vm._l((folder.versions), function(version) {
      return _c('version-element', {
        key: version.id,
        attrs: {
          "project": _vm.project,
          "version": version,
          "auto-kind": folder.kind
        },
        on: {
          "promoteVersion": _vm.promoteVersion,
          "deleteVersion": _vm.deleteVersion,
          "close": _vm.emitClose
        }
      })
    }), 1)], 1)], 1)
  }), _vm._v(" "), (_vm.autoSaveCapEnabled && _vm.autoFolders.length) ? _c('li', {
    staticClass: "ql-history-help"
  }, [_vm._v("\n                    Each folder keeps its " + _vm._s(_vm.autoSaveCap) + " most recent. Manual saves are kept until you delete them. Rename one to keep it.\n                ")]) : _vm._e()], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bca8a92e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/history/versions-nav.vue
// module id = 1285
// module chunks = 21